// extracted by mini-css-extract-plugin
export default {"table":"MicropileSlipPlaneSummary_table__3ka36","value":"MicropileSlipPlaneSummary_value__pyXyu","underline":"MicropileSlipPlaneSummary_underline__rVslg"};